/* @jsx h */
import { isPackaged } from "@lemmonhq/orders";
import { defineComponent, h, onMounted } from "vue";
import { RouterView } from "vue-router";
import { Navbar } from "./LayoutComponents/Navbar";
import { isMobileTabBarPrototypeEnabled } from "./LayoutComponents/Navbar/mobileTabBarPrototype";

export const GroupShell = defineComponent({
  name: "GroupShell",
  setup() {
    const env = (window as any).lemmonEnv;
    const safeAreaTop = env?.packagingInfo?.statusBarHeight || 0;
    const hasSafeArea = safeAreaTop > 0;
    const useMobileTabBar = isMobileTabBarPrototypeEnabled();

    onMounted(() => {
      if (hasSafeArea) {
        document.documentElement.style.setProperty(
          "--safe-area-top",
          `${safeAreaTop}px`,
        );
      }
    });

    return () => {
      const paddingTopStyle = isPackaged
        ? "calc(0px + var(--safe-area-top, 0px))"
        : "0px";

      return (
        <div
          style={{ paddingTop: paddingTopStyle }}
          class={[
            "flex h-screen flex-col overflow-hidden text-base-content",
            useMobileTabBar
              ? "max-[698px]:pb-[calc(3.75rem+env(safe-area-inset-bottom))]"
              : "",
          ]}
        >
          <div
            class={[
              "border-b",
              hasSafeArea ? "pb-2" : "py-2",
              useMobileTabBar ? "max-[698px]:border-b-0 max-[698px]:p-0" : "",
            ]}
          >
            <Navbar mode="group" />
          </div>
          <main class="min-h-0 flex-1 overflow-y-auto">
            <RouterView />
          </main>
        </div>
      );
    };
  },
});
